import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={687}
    height={231}
    viewBox="0 0 687 231"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M551.905 97.8839C526.836 96.6408 464.163 126.889 464.163 126.889C464.163 126.889 488.536 102.027 494.803 92.0829C501.07 82.1382 508.034 58.934 531.014 57.2765C553.994 55.6191 574.885 66.3924 586.723 74.6797C598.561 82.9669 652.878 122.746 652.878 122.746C652.878 122.746 625.023 119.431 612.489 114.458C599.954 109.486 576.974 99.127 551.905 97.8839Z"
      fill="url(#paint0_linear_19_213)"
    />
    <path
      d="M48.4315 209.761C40.7715 215.148 29.8491 214.225 27.2099 205.937C24.5708 197.65 15.3337 162.429 15.3337 162.429C15.3337 162.429 28.5295 190.606 35.7872 189.777C43.0448 188.949 60.9661 171.226 76.2862 173.298C91.6063 175.369 114.586 206.446 130.603 206.861C146.619 207.275 141.745 198.574 163.332 198.574C184.919 198.574 175.17 202.303 203.025 198.574C230.88 194.844 249.163 113 280.5 113C311.837 113 341.602 128.961 341.602 128.961C341.602 128.961 301.909 138.077 285.196 159.624C268.483 181.17 260.127 206.032 253.163 214.734C246.2 223.435 235.754 228.822 219.041 230.479C202.329 232.137 134.781 209.761 125.728 209.761C116.675 209.761 122.246 214.734 110.408 212.248C98.57 209.761 82.5535 194.016 73.5007 196.502C64.448 198.988 56.0916 204.375 48.4315 209.761Z"
      fill="url(#paint1_linear_19_213)"
    />
    <path
      d="M374 27C362.5 23 344.387 32.0006 344.387 32.0006L394.526 55.2048H412.631C412.631 55.2048 385.5 31 374 27Z"
      fill="url(#paint2_linear_19_213)"
    />
    <path
      d="M398.008 53.5473C398.008 53.5473 372.938 41.0217 354.833 34.0723C336.727 27.1229 322.104 26.1995 322.104 26.1995C322.104 26.1995 338.12 49.4037 354.833 51.4755C371.546 53.5473 398.008 53.5473 398.008 53.5473Z"
      fill="url(#paint3_linear_19_213)"
    />
    <path
      d="M395.919 91.2542C347.173 84.21 340.906 55.5244 340.906 55.5244C340.906 55.5244 370.153 73.0223 390.348 73.0223C410.542 73.0223 444.664 48.575 444.664 48.575C444.664 48.575 492.692 5.99053 520.568 2.58091C548.444 -0.828706 599.982 21.5468 611.124 24.4473C625.939 28.304 644.792 20.2847 659.842 16.2548C659.842 16.2548 638.254 35.7298 616.667 35.3154C595.08 34.9011 567.225 17.9123 535.888 19.9841C504.552 22.0559 444.664 98.2983 395.919 91.2542Z"
      fill="url(#paint4_linear_19_213)"
    />
    <path
      d="M185.616 113.215C179.349 118.188 164.028 128.132 164.028 128.132C164.028 128.132 185.616 131.033 193.276 128.132C235.364 112.195 224.634 66.698 265.002 49.4037C282.411 41.9452 329.764 53.1329 338.817 56.4478C347.869 59.7627 368.76 73.0222 381.295 74.2653C393.83 75.5084 408.453 73.5873 414.721 70.5361C420.988 67.4849 446.057 48.1606 446.057 48.1606C446.057 48.1606 430.041 54.376 411.239 53.5473C392.437 52.7186 380.372 53.6758 361.1 50.6467C324.193 44.8457 310.266 -2.39143 285.893 0.094705C261.52 2.58084 253.86 46.9175 243.414 56.4478C232.969 65.9781 218.345 70.5361 211.381 74.2653C204.418 77.9946 191.883 108.243 185.616 113.215Z"
      fill="url(#paint5_linear_19_213)"
    />
    <path
      d="M44.2533 135.176C36.5933 145.535 19.9522 145.026 16.6533 144.198C13.3543 143.369 0.818298 140.054 0.818298 140.054C0.818298 140.054 24.5707 154.332 33.8078 152.994C43.0449 151.656 46.3424 148.85 46.3424 148.85L70.0189 131.447L96.4808 139.734L129.21 128.132H166.814C166.814 128.132 181.438 119.016 187.009 114.044C192.579 109.072 205.81 78.8233 212.078 75.094C218.345 71.3648 222.625 69.9862 227.5 67.5C232.375 65.0138 235.754 62.2489 235.754 62.2489C235.754 62.2489 225.309 41.637 207.203 43.9223C189.098 46.2075 180.045 82.8722 171.688 96.5461C163.332 110.22 144.53 121.822 136.87 123.894C129.21 125.966 111.105 132.276 97.8736 128.961C84.6426 125.646 83.9462 100.784 70.0189 99.5414C56.0915 98.2983 51.9133 124.817 44.2533 135.176Z"
      fill="url(#paint6_linear_19_213)"
    />
    <path
      d="M556.779 62.6632C529.621 56.8278 520.568 62.6632 520.568 62.6632C520.568 62.6632 549.119 44.0172 576.974 52.3044C604.829 60.5916 635.469 92.0832 656.36 94.9835C677.251 97.8839 687 93.3261 687 93.3261V126.475C687 126.475 673.769 130.204 651.485 124.817C629.202 119.431 583.938 68.4986 556.779 62.6632Z"
      fill="url(#paint7_linear_19_213)"
    />
    <path
      d="M52.6097 133.105C49.8242 140.149 46.3424 144.292 46.3424 144.292C46.3424 144.292 56.7879 134.762 67.2334 137.248C77.6789 139.734 90.2135 152.58 101.355 154.237C112.497 155.894 131.996 145.95 147.316 146.778C162.636 147.607 190.49 159.209 207.9 150.922C225.309 142.635 239.236 123.16 239.236 123.16C239.236 123.16 277.536 64.735 293.553 63.4919C327.429 60.8627 353.916 103.592 393.83 101.613C437.038 99.4706 463.967 73.9447 490.625 56.8622C490.625 56.8622 521.265 36.9728 539.37 35.3154C577.531 31.822 616.26 50.7186 654.271 44.017C673.073 40.7021 687 28.5909 687 28.5909V6.21542C687 6.21542 673.073 9.62502 657.753 15.8404C642.433 22.0559 637.558 31.95 615.274 33.2436C592.99 34.5372 583.241 20.3984 536.585 17.9122C509.84 16.4871 490.741 40.3041 465.555 59.3483C446.805 73.5265 422.293 84.6401 401.49 88.3536C352.744 97.0552 327.675 19.1553 293.553 19.1553C259.431 19.1553 216.256 119.431 189.794 125.646C163.332 131.861 154.976 119.431 138.959 119.431C122.943 119.431 114.586 129.375 104.141 134.762C83.714 145.296 74.7948 119.431 62.3588 119.431C57.4843 119.431 55.3952 126.06 52.6097 133.105Z"
      fill="url(#paint8_linear_19_213)"
    />
    <path
      d="M75.5898 174.032C67.2334 174.446 45.0242 192.169 35.7872 193.921C26.5501 195.673 13.3543 156.628 13.3543 156.628C13.3543 156.628 29.8491 170.397 33.8078 170.302C37.7665 170.208 40.7715 166.668 45.646 160.038C50.5206 153.408 54.6988 151.337 62.3588 152.165C70.0189 152.994 82.5535 168.74 93.6954 173.298C104.837 177.856 130.603 186.972 143.834 186.557C157.065 186.143 191.883 190.701 208.596 183.242C225.309 175.784 235.754 166.159 235.754 166.159C235.754 166.159 222.523 198.159 199.543 203.546C176.563 208.933 171.688 201.06 159.154 199.817C146.619 198.574 143.834 208.518 129.21 208.104C114.586 207.69 83.9462 173.617 75.5898 174.032Z"
      fill="url(#paint9_linear_19_213)"
    />
    <path
      d="M214.167 165.425C191.883 185.314 166.118 186.877 166.118 186.877C166.118 186.877 191.883 190.36 202.329 187.8C212.774 185.241 227.398 181.076 237.147 166.573C246.896 152.07 247.592 123.989 289.374 121.917C331.157 119.845 391.044 149.265 436.308 141.806C481.572 134.348 509.426 73.4366 509.426 73.4366C509.426 73.4366 460.681 121.917 409.15 121.917C357.618 121.917 313.747 92.0829 285.196 92.4972C256.645 92.9116 236.451 145.535 214.167 165.425Z"
      fill="url(#paint10_linear_19_213)"
    />
    <path
      d="M60.2697 164.182C47.7351 167.177 40.4057 176.932 33.8078 177.441C27.2099 177.95 8.07599 149.17 8.07599 149.17C8.07599 149.17 29.8491 169.568 33.8078 169.059C37.7665 168.55 40.7715 166.668 45.646 160.038C50.5206 153.408 54.6988 151.336 62.3588 152.165C70.0189 152.994 75.5898 158.286 79.0717 160.772L92.999 170.717C92.999 170.717 72.8044 161.186 60.2697 164.182Z"
      fill="#423FCF"
    />
    <path
      d="M62.3588 144.707C54.0024 145.121 39.7459 160.772 33.8078 161.696C27.8697 162.619 0.818298 140.054 0.818298 140.054C0.818298 140.054 26.5501 174.635 33.8078 171.226C41.0655 167.816 40.7715 166.668 45.646 160.038C50.5206 153.408 54.6988 151.337 62.3588 152.165C70.0189 152.994 82.5535 168.74 93.6954 173.298C104.837 177.856 112.497 195.578 143.834 190.192C175.17 184.805 177.259 190.287 193.972 182.828C210.685 175.369 229.487 148.85 229.487 148.85C229.487 148.85 212.078 160.038 193.972 161.696C175.867 163.353 167.51 157.552 154.976 156.309C142.441 155.066 124.336 164.596 109.712 164.182C95.0881 163.767 70.7152 144.292 62.3588 144.707Z"
      fill="url(#paint11_linear_19_213)"
    />
    <path
      d="M69.3225 135.176C55.3952 133.519 41.0655 150.413 33.8078 150.413C26.5501 150.413 0.818298 140.054 0.818298 140.054C0.818298 140.054 26.5501 164.501 33.8078 162.844C41.0655 161.186 53.3061 145.95 62.3588 145.121C71.4116 144.292 93.6954 163.767 107.623 165.01C121.55 166.253 144.53 155.894 154.976 158.381C165.421 160.867 175.17 165.01 191.187 165.01C207.203 165.01 221.827 156.723 228.094 151.751C256.815 128.964 263.609 82.5525 301.213 80.0664C338.817 77.5802 353.44 107.829 402.882 109.072C456.605 110.422 505.945 46.5031 545.638 43.6026C582.861 40.8825 622.934 50.2324 650.093 53.5473C677.251 56.8621 687 51.0611 687 51.0611V28.2712C687 28.2712 670.287 41.1164 650.093 42.3595C629.898 43.6026 625.72 39.0446 599.954 39.0446C574.189 39.0446 568.618 29.9287 535.192 32.4148C501.766 34.901 445.361 99.9557 398.704 99.127C352.047 98.2982 323.496 56.8621 294.249 59.7627C265.002 62.6632 233.394 147.607 196.758 150.093C160.121 152.58 163.332 142.635 148.708 142.221C134.085 141.806 131.299 151.751 111.105 151.751C90.9099 151.751 83.2499 136.834 69.3225 135.176Z"
      fill="url(#paint12_linear_19_213)"
    />
    <path
      d="M687 65.9784C687 65.9784 676.555 70.2422 648.004 68.0499C633.918 66.9684 602.043 54.376 578.367 47.7462C554.017 42.3491 537.978 44.8457 537.978 44.8457C537.978 44.8457 558.869 36.9726 592.294 43.1883C625.72 49.404 638.951 49.8183 656.36 51.8902C673.769 53.9621 687 49.4041 687 49.4041V65.9784Z"
      fill="url(#paint13_linear_19_213)"
    />
    <path
      d="M264 104.5C264 104.5 279.625 77.5802 306.087 77.5802C332.549 77.5802 367.368 106.585 402.186 106.585C437.004 106.585 510.123 52.9068 543.548 50.6467C564.954 49.1993 575.793 52.3247 583.381 56.1744C587.272 57.7249 590.963 59.8648 594.383 62.6632C590.877 60.7261 587.642 58.3361 583.381 56.1744C559.776 46.7669 528.841 59.0535 506.641 77.5802C480.782 99.1603 466.252 115.701 419.595 123.16C372.938 130.618 308 94 289.5 94.5C271 95 264 104.5 264 104.5Z"
      fill="url(#paint14_linear_19_213)"
    />
    <path
      d="M547.124 42.6792C515.092 42.6792 483.5 74.5 483.5 74.5C483.5 74.5 525.443 53.5472 545.637 51.8898C565.832 50.2325 579.063 54.7901 587.419 58.9339C595.776 63.0776 638.951 93.7401 656.36 95.812C673.769 97.8839 687 95.812 687 95.812V65.978C687 65.978 678.644 68.1702 650.092 65.978C621.541 63.7858 579.157 42.6792 547.124 42.6792Z"
      fill="url(#paint15_linear_19_213)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_19_213"
        x1={558.52}
        y1={57.1061}
        x2={558.52}
        y2={126.889}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1D2575" />
        <stop offset={1} stopColor="#080D3F" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_19_213"
        x1={188.401}
        y1={116.53}
        x2={188.401}
        y2={230.567}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#212980" />
        <stop offset={1} stopColor="#01042D" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_19_213"
        x1={378.509}
        y1={23.8438}
        x2={378.509}
        y2={55.2048}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#80E1EE" />
        <stop offset={1} stopColor="#73ACFF" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_19_213"
        x1={360.056}
        y1={26.1995}
        x2={360.056}
        y2={53.5473}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A9FFFF" />
        <stop offset={1} stopColor="#8BADEE" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_19_213"
        x1={501.418}
        y1={2.33504}
        x2={501.418}
        y2={91.7137}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#ADA7F7" />
        <stop offset={1} stopColor="#6E65DB" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_19_213"
        x1={305.043}
        y1={0}
        x2={305.043}
        y2={129.421}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#AFA6F1" />
        <stop offset={1} stopColor="#8071F2" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_19_213"
        x1={135.477}
        y1={43.334}
        x2={135.477}
        y2={152.994}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#7E78EC" />
        <stop offset={1} stopColor="#5750CB" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_19_213"
        x1={589.509}
        y1={59.2536}
        x2={631.181}
        y2={149.532}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4148B6" />
        <stop offset={1} stopColor="#171D79" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_19_213"
        x1={141.048}
        y1={122.236}
        x2={630.68}
        y2={-120.744}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#7E76EE" />
        <stop offset={0.535} stopColor="#7CDEF3" />
        <stop offset={1} stopColor="#8989EA" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_19_213"
        x1={132.692}
        y1={151.992}
        x2={132.692}
        y2={208.117}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#20257B" />
        <stop offset={1} stopColor="#0F1680" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_19_213"
        x1={214.863}
        y1={151.656}
        x2={478.9}
        y2={17.6216}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0013EB" />
        <stop offset={1} stopColor="#0B1257" />
      </linearGradient>
      <linearGradient
        id="paint11_linear_19_213"
        x1={82.5534}
        y1={155.8}
        x2={182.422}
        y2={186.717}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5E51ED" />
        <stop offset={1} stopColor="#0009B8" />
      </linearGradient>
      <linearGradient
        id="paint12_linear_19_213"
        x1={142.441}
        y1={117.264}
        x2={610.382}
        y2={-74.8285}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6357EC" />
        <stop offset={1} stopColor="#4B7AFF" />
      </linearGradient>
      <linearGradient
        id="paint13_linear_19_213"
        x1={594.383}
        y1={46.4084}
        x2={662.46}
        y2={103.182}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#526BEF" />
        <stop offset={1} stopColor="#2946E0" />
      </linearGradient>
      <linearGradient
        id="paint14_linear_19_213"
        x1={370}
        y1={66.5}
        x2={555.5}
        y2={43}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#212DEB" />
        <stop offset={1} stopColor="#4D57EC" />
      </linearGradient>
      <linearGradient
        id="paint15_linear_19_213"
        x1={560.957}
        y1={51.3808}
        x2={642.244}
        y2={141.196}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4955FF" />
        <stop offset={1} stopColor="#2E38BE" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgComponent;
